import { useState } from 'react';
import { socieApi } from '../services/api';
import '../styles/Modal.css';

function UploadSOCIEModal({ entity, onClose, onComplete }) {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Validate file type
      const fileName = selectedFile.name.toLowerCase();
      if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        setError('Please select a valid Excel file (.xlsx or .xls)');
        setFile(null);
        return;
      }
      setFile(selectedFile);
      setError(null);
      setUploadResult(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file to upload');
      return;
    }

    try {
      setUploading(true);
      setError(null);
      const result = await socieApi.uploadMovements(entity.name, file);
      setUploadResult(result);

      // Auto-close and trigger refresh after 2 seconds
      setTimeout(() => {
        if (onComplete) onComplete();
      }, 2000);
    } catch (err) {
      setError('Failed to upload input data: ' + err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Upload SOCIE Input Data</h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {error && <div className="alert alert-error">{error}</div>}
          {uploadResult && (
            <div className="alert alert-success">
              <p><strong>Upload Successful!</strong></p>
              {uploadResult.equity_data && (
                <p>Equity Share Capital: {Object.keys(uploadResult.equity_data).length} fields</p>
              )}
              {uploadResult.other_equity_data && (
                <p>Other Equity: {Object.keys(uploadResult.other_equity_data).length} fields</p>
              )}
              <p>File stored successfully in S3</p>
            </div>
          )}

          <div className="form-group">
            <label>Entity:</label>
            <input
              type="text"
              value={entity.name}
              disabled
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label>SOCIE Input File:</label>
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              className="form-control"
              disabled={uploading}
            />
            <small className="form-text">
              Upload the filled SOCIE template with equity share capital and other equity data (.xlsx or .xls)
            </small>
          </div>

          {file && (
            <div className="file-info">
              <p><strong>Selected file:</strong> {file.name}</p>
              <p><strong>Size:</strong> {(file.size / 1024).toFixed(2)} KB</p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onClose}
            disabled={uploading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleUpload}
            disabled={!file || uploading}
          >
            {uploading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UploadSOCIEModal;
